import './modal-paused-game.scss';
import Button from '../../components/button/button';
import PausedGame from '../../assets/paused-game.png';
import ModalTemplate from '../modal-template/modal-template';
import TranslateService from '../../services/translate-service';

export default function ModalPausedGame(props) {

    return (
        <ModalTemplate isOpen={props.isOpen} className="modal-paused-game">
            <div className='text-center'>
                <img src={PausedGame} alt='' className='m-auto' />

                <h1 className='heading-h3'>{TranslateService.get('modal.pausedGame.title')}</h1>

                <p className='mt-[16px] mb-[24px]'>
                {TranslateService.get('modal.pausedGame.description')}
                </p>

                <Button onClick={props.onClose} >
                {TranslateService.get('modal.pausedGame.btn')}
                </Button>
            </div>

        </ModalTemplate>

    )
}